import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, TransferAsset } from 'assets-model';
import { TransferAssetItemComponent } from './transfer-asset-item.component';
import { TRANSFER_ASSET_TYPE } from 'assets-model';


@Component({
  selector: 'app-transfer-asset-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class TransferAssetEditorComponent extends CrudEditComponent<TransferAsset, number> implements OnInit {

  get transferAssetItemComponent(): TransferAssetItemComponent {
    return <TransferAssetItemComponent>this.itemComponent;
  }

  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    const self = this;
    this.actions = [];
    if (!this.createMode) {
      if (!this.readOnly) {
        this.actions.push(<Action>{
          title: 'View Asset',
          get enabled(): boolean {
            return self.isViewAssetEnabled();
          },
          color: true,
          get available(): boolean {
            return !self.readOnly && self.userStorage.currentUserHasAnyAuthority(TRANSFER_ASSET_TYPE.editAuthorities);
          },
          doAction() {
            self.viewAssetAction();
          }
        });
      }
    }
  }

  isViewAssetEnabled() {
    return (this.eAssetsUser?.businessUnit?.buId == this.item.asset?.businessUnit?.buId ||
      this.userStorage.currentUserHasAnyAuthority('ACTS_AT_NATIONAL_LEVEL'));
  }

  viewAssetAction() {
    this.router.navigate(['asset/view/', this.item.asset.assetId]);
  }


  backRoute(): any[] {
    return ['/assets'];
  }

  currentUserIsCreator(): boolean {
    return this.userDetails?.username == this.item.createdBy;
  }

  isEditEnabled() {
    return (this.userStorage?.currentUserHasAnyAuthority("APPROVE_TRANSFER_ASSET") && !this.currentUserIsCreator());
  }

  isSaveEnabled() {
    return super.isSaveEnabled() && this.isEditEnabled();
  }

}






